// extracted by mini-css-extract-plugin
module.exports = {"primary":"#ee4540","toggle":"#35c759","secondary":"#30ab8a"};